(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminPasswordDisplaySettingsController', AdminPasswordDisplaySettingsController);

    function AdminPasswordDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'password_days_till_change_notification',
                'password_disallow_previous_passwords',
                'password_force_change',
                'password_min_characters',
                'password_require_number',
                'password_require_punctuation',
                'password_require_uppercase'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);
    }
})();
